import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { AuthShell } from "@/pages/auth/AuthShell";
import { useI18n } from "@/context/I18nContext";
import api from "@/lib/api";

export default function VerifyEmail() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    if (!token) { setStatus("fail"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setStatus("ok"))
      .catch(() => setStatus("fail"));
  }, [token]);

  return (
    <AuthShell title={t("auth.verifyTitle")} subtitle="">
      <div className="text-center space-y-4" data-testid="verify-status">
        {status === "verifying" && <p className="text-muted-foreground">{t("auth.verifying")}</p>}
        {status === "ok" && <p className="text-lg font-medium text-primary">{t("auth.verified")}</p>}
        {status === "fail" && <p className="text-destructive">{t("auth.verifyFail")}</p>}
        <Link to="/login" className="inline-block text-primary text-sm font-medium">{t("auth.backToLogin")}</Link>
      </div>
    </AuthShell>
  );
}
